// Approved 3D Lumi character set — /public/images/lumi/3d/ (transparent PNGs, use as supplied: never crop, stretch, or recolor).
// The character sheet is an INTERNAL reference only (kept in /app/memory/lumi-reference/, never served publicly).
const BASE = "/images/lumi/3d";

export const LUMI_POSES = {
  waving: `${BASE}/Lumi_3D_Waving.png`,            // greeting, starting an activity
  speaking: `${BASE}/Lumi_3D_Speaking.png`,        // directions, clues, word introductions
  reading: `${BASE}/Lumi_3D_Reading.png`,          // Story Magic, sentences, passages
  celebrating: `${BASE}/Lumi_3D_Celebrating.png`,  // correct answers, badges, completions
  flying: `${BASE}/Lumi_3D_Flying.png`,            // brief transitions only
  sitting: `${BASE}/Lumi_3D_Sitting.png`,          // calm waiting, longer instructions
  thinking: `${BASE}/Lumi_3D_Thinking_Almost.png`, // first incorrect response
  tryAgain: `${BASE}/Lumi_3D_Try_Again.png`,       // gentle additional attempt (never "sad")
};

export const LUMI_ALT = {
  waving: "Lumi waves hello.",
  speaking: "Lumi explains the next step.",
  reading: "Lumi reads a story.",
  celebrating: "Lumi celebrates your progress.",
  flying: "Lumi flies to the next adventure.",
  sitting: "Lumi waits calmly with you.",
  thinking: "Lumi thinks about the answer.",
  tryAgain: "Lumi encourages you to try again.",
};

export const LUMI_MESSAGES = {
  greeting: ["Hi! I'm Lumi. Let's learn some new words!"],
  celebrate: ["You did it!", "Great thinking!", "Wonderful work!", "Your words are growing!", "I knew you could do it!"],
  thinking: ["Almost! Let's think about it.", "Good try! Look at the choices again.", "You're learning. Let's try once more.", "Hmm…which answer fits best?"],
  tryAgain: ["Good try! Let's choose again.", "That one was tricky. Try another answer.", "It's okay to make mistakes. Let's try together.", "Would you like a clue?"],
  sitting: ["Take your time. I'm right here with you."],
};

export const pickMessage = (key) => {
  const list = LUMI_MESSAGES[key] || [];
  return list[Math.floor(Math.random() * list.length)] || "";
};
